<div class="app-calendar-header">
  <span class="app-calendar-header-label">{{periodLabel}}</span>
    <button mat-icon-button (click)="previousClicked('month')" [disabled]="previousbuttondisabled">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="nextClicked('month')">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
</div>
<app-splitter class='app-splitter' [config]="'horizontal 91% 0.8rem -.6rem 34.375rem'"></app-splitter>